
(function(){
  var ATTR="data-ss-grow",MAX=10;
  function num(v,fb){var n=parseFloat(v);return isNaN(n)?fb:n}
  // A box is measured again whenever its own width changes. Measured while narrow
  // (a phone's comment rail mid-slide, a toolbar resize), wrapped text reads as
  // many lines, and the height used to stay when the box came back to full width:
  // a 240px whole-page composer holding one placeholder line (2026-10-07).
  // Only width counts, so the height this writes never calls back into it.
  var ro=window.ResizeObserver?new ResizeObserver(function(es){
    for(var i=0;i<es.length;i++){
      var el=es[i].target,w=Math.round(es[i].contentRect.width);
      if(el.__ssGrowW===w)continue;
      var first=el.__ssGrowW===undefined;el.__ssGrowW=w;
      if(!first)requestAnimationFrame((function(x){return function(){size(x)}})(el));
    }
  }):null;
  function watch(ta){if(ro&&!ta.__ssGrowOn){ta.__ssGrowOn=1;ro.observe(ta)}}
  function size(ta){
    if(!ta||ta.tagName!=="TEXTAREA"||!ta.hasAttribute(ATTR))return;
    watch(ta);
    // A box with no layout reports scrollHeight 0, and writing that back pins it
    // at zero until the first keystroke. The composers that start hidden (the
    // dashboard's, behind "New space") are measured when they are shown instead.
    if(!ta.getClientRects().length)return;
    // Empty is the box's own size (rows, min-height). scrollHeight would measure the
    // placeholder, which wraps in a narrow box and has nothing to show anyway.
    if(!ta.value){ta.style.height="";ta.style.overflowY="";return}
    var cs=window.getComputedStyle(ta);
    // "normal" computes to the string, not a number: fall back to the ratio the
    // app's composers use rather than to a bare font-size, which would cap a
    // ten-line box at about seven lines of actual text.
    var lh=num(cs.lineHeight,num(cs.fontSize,16)*1.4);
    var pad=num(cs.paddingTop,0)+num(cs.paddingBottom,0);
    var bord=num(cs.borderTopWidth,0)+num(cs.borderBottomWidth,0);
    // scrollHeight is content + padding whichever box model is in play; what the
    // height property then means is the part that differs.
    var box=cs.boxSizing==="border-box"?pad+bord:0;
    var lines=parseInt(ta.getAttribute(ATTR),10);
    if(!(lines>0))lines=MAX;
    var max=lines*lh+box;
    // A phone with the keyboard up has a few hundred pixels of viewport, and ten
    // lines of it is the whole thread gone. visualViewport is the keyboard-aware
    // height where it exists; the floor keeps two lines readable whatever it says.
    var vh=(window.visualViewport&&window.visualViewport.height)||window.innerHeight||0;
    if(vh)max=Math.max(2*lh+box,Math.min(max,Math.round(vh*0.45)));
    // Shrink first, or scrollHeight only ever reports the height it already has.
    ta.style.height="auto";
    var want=Math.max(0,ta.scrollHeight-pad)+box;
    ta.style.height=Math.min(want,max)+"px";
    ta.style.overflowY=want>max?"auto":"hidden";
  }
  window.ssAutoGrow=function(el){
    if(typeof el==="string")el=document.getElementById(el);
    size(el);
  };
  // One pair of listeners for the whole page: the reply boxes are built as
  // innerHTML when someone opens a thread, and binding on creation is the step
  // that gets missed. Focus counts as well as typing — it is when a composer that
  // was hidden at load first has a size to measure.
  document.addEventListener("input",function(e){size(e.target)},true);
  document.addEventListener("focusin",function(e){size(e.target)},true);
  // A value that was there before any keystroke — a server-rendered draft, one
  // restored from sessionStorage — still has to be measured once.
  function all(){
    var list=document.querySelectorAll("textarea["+ATTR+"]");
    for(var i=0;i<list.length;i++)size(list[i]);
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",all);
  else all();
  // Re-wrapping at a new width changes how many lines the same text takes.
  var t=null;
  window.addEventListener("resize",function(){clearTimeout(t);t=setTimeout(all,120)});
})();
